import { inviteService } from '@/services/invites.service';

const initialState = () => ({
  status: {
    error: null,
    pending: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  acceptInvite({ commit }, { token, user }) {
    commit('ACCEPT_INVITE');
    return inviteService
      .acceptInvite({ token, user })
      .then((response) => {
        commit('SUCCESS');
        return response;
      })
      .catch((error) => {
        commit('ERROR', error);
        throw error;
      });
  },
};

const mutations = {
  ACCEPT_INVITE(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  SUCCESS(state) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
  },
  ERROR(state, error) {
    state.status = {
      ...state.status,
      error: error,
      pending: false,
      rejected: true,
    };
  },
};
const getters = {
  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  resolved: (state) => state.status.resolved,
  rejected: (state) => state.status.rejected,
};

export const acceptInvite = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
